import { api } from './api';

export interface FeedbackSummary {
  total: number;
  helpful: number;
  unhelpful: number;
  helpfulRate: number | null;
  byKind: { kind: 'ask' | 'search'; helpful: number; unhelpful: number }[];
  recentNegatives: { query: string | null; note: string | null; kind: 'ask' | 'search'; createdAt: string }[];
}

export interface VoteBody {
  kind: 'ask' | 'search';
  targetId: string;
  vote: 1 | -1;
  query?: string;
  citedChunkIds?: (string | number)[];
  note?: string;
}

export const feedbackApi = {
  async vote(wsId: string, body: VoteBody): Promise<{ ok: boolean; vote: number }> {
    const r = await api.post<{ ok: boolean; vote: number }>(`/api/workspaces/${wsId}/feedback`, body);
    return r.data;
  },
  async summary(wsId: string): Promise<FeedbackSummary> {
    const r = await api.get<FeedbackSummary>(`/api/workspaces/${wsId}/feedback/summary`);
    return r.data;
  },
};
